import { Money, formatMoney } from '@betterment/js-runtime';
import { Box, Button, Dialog, Heading, Icon, Separator, Text } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';

export type WashSaleDetectedParams = {
  netWashedLosses: Money;
  explanationHtml: string;
};

export const WashSaleDetectedDialog: React.FC<WashSaleDetectedParams> = ({ netWashedLosses, explanationHtml }) => {
  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <Box
          css={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box css={{ alignSelf: 'center' }}>
            <Text>Tax impact</Text>
          </Box>
          <Box css={{ display: 'flex' }}>
            <Text css={{ alignSelf: 'end' }}>{netWashedLosses.cents > 0 ? 'Wash sale detected' : 'None'}</Text>
            <Icon name="CaretRight" size="small" color="icon" />
          </Box>
        </Box>
      </Dialog.Trigger>
      <Dialog.Content
        aria-describedby={undefined}
        css={{
          display: 'grid',
          gap: 'space.100',
          p: 'space.400',
          overflowY: 'auto',
        }}
        size="large"
      >
        <Dialog.Title id="tax-monitoring-detail" asChild={true}>
          <Heading as="h2" variant="pageTitle">
            {netWashedLosses.cents > 0 ? 'Estimated tax impact' : 'No estimated tax impact'}
          </Heading>
        </Dialog.Title>
        <Separator css={{ marginY: 'space.200' }} />
        <ErrorBoundary fallbackType="partial">
          {netWashedLosses.cents > 0 && (
            <Text css={{ fontWeight: 'medium' }} variant="text300">
              {formatMoney(netWashedLosses)}
            </Text>
          )}
          <Box
            css={{
              marginY: 'space.200',
            }}
          >
            <Box css={{ padding: 'space.200', backgroundColor: 'primitives.gold.10' }}>
              <Text dangerouslySetInnerHTML={{ __html: explanationHtml }} />
            </Box>
          </Box>
          <Box>
            <Text css={{ color: 'primitives.grey.50' }}>
              Actual tax results are likely to be different depending on specific circumstances, including but not
              limited to, the marginal tax rate applicable to you, any subsequent trading activity, the presence of
              other capital gains or losses for the year, and securities prices at the moment you execute trade.
              Furthermore, transactions made at brokerages other than Betterment cannot be taken into account, and could
              effect these estimates. This is not tax advice.
            </Text>
          </Box>
          <Box css={{ marginTop: 'space.200' }}>
            <Dialog.Close asChild={true}>
              <Button variant="solidSecondary" css={{ display: 'inline' }}>
                Close
              </Button>
            </Dialog.Close>
          </Box>
        </ErrorBoundary>
      </Dialog.Content>
    </Dialog>
  );
};
